// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hr-org-body{
    border-bottom: 1.27532px solid #EAEAEA;
}
.hr-org-title{
border-bottom:1.894px solid rgba(140, 174, 120, 0.12);
}
.hi-name{
padding: 0 7%;
color: #424242;
font-size: 30px;
margin-top:2rem;
}
.db-tabs-div{
padding: 0 7%;    
}
.db-tabs-div .MuiButtonBase-root{
padding:0 !important;
min-width:auto !important;
margin-right:30px;
margin-top: 10px;
}
.db-tab{
color: #424242 !important;
opacity: 0.6 !important;
font-size:14px !important;
}
.db-tabs-div .Mui-selected{
color:#68AD3F !important;
opacity: 1 !important;  
}
.db-body{
background-color: #FAFAFA;
padding: 0 7%;
min-height:90vh;
padding-bottom: 100px;
}
.db-org-title{
color:#424242;
font-size:22px;
font-weight: 500;
}
.db-dropdown .dropdown-toggle::after {
display: none;
}
.create-event-opt{
cursor:pointer;
height: 42px;
font-size: 14px;
color: #000000;
}
.db-tab-container .MuiTabPanel-root{
padding: 0 !important;
}
.dashboardPopover  .MuiPopover-paper {
right: 7% !important;
width: 185px !important;
left: auto !important;
}

@media only screen and (min-width: 0px) and (max-width: 480px) {
.hi-name{
    padding: 0 5%;
}
.dashboardPopover .MuiPopover-paper {
    right: 5% !important;
}
.db-body{
    padding: 0 5%;
}
.db-tabs-div{
    padding: 0 5%;    
}
.create-event{
    font-size: 12px;
    padding:7px 9px;
}
.db-tabs-div .MuiTabs-indicator{
bottom: 0px !important;
}
}

@media only screen and (min-width: 481px) and (max-width: 767px) {
.hi-name{
    padding: 0 5%;
}
.dashboardPopover .MuiPopover-paper {
    right: 5% !important;
}
.db-body{
    padding: 0 5%;
}
.db-tabs-div{
    padding: 0 5%;    
}
.db-tabs-div .MuiTabs-indicator{
    bottom: 0px !important;
}
}

@media only screen and (min-width: 768px) and (max-width: 1024px) {
    .db-body,.db-tabs-div,.hi-name{
        padding: 0 7%;
    }
    .dashboardPopover .MuiPopover-paper {
        right: 7% !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/Organizer/Dashboard/DashboardOrg.css"],"names":[],"mappings":"AAAA;IACI,sCAAsC;AAC1C;AACA;AACA,qDAAqD;AACrD;AACA;AACA,aAAa;AACb,cAAc;AACd,eAAe;AACf,eAAe;AACf;AACA;AACA,aAAa;AACb;AACA;AACA,oBAAoB;AACpB,yBAAyB;AACzB,iBAAiB;AACjB,gBAAgB;AAChB;AACA;AACA,yBAAyB;AACzB,uBAAuB;AACvB,yBAAyB;AACzB;AACA;AACA,wBAAwB;AACxB,qBAAqB;AACrB;AACA;AACA,yBAAyB;AACzB,aAAa;AACb,eAAe;AACf,qBAAqB;AACrB;AACA;AACA,aAAa;AACb,cAAc;AACd,gBAAgB;AAChB;AACA;AACA,aAAa;AACb;AACA;AACA,cAAc;AACd,YAAY;AACZ,eAAe;AACf,cAAc;AACd;AACA;AACA,qBAAqB;AACrB;AACA;AACA,oBAAoB;AACpB,uBAAuB;AACvB,qBAAqB;AACrB;;AAEA;AACA;IACI,aAAa;AACjB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,eAAe;IACf,eAAe;AACnB;AACA;AACA,sBAAsB;AACtB;AACA;;AAEA;AACA;IACI,aAAa;AACjB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,sBAAsB;AAC1B;AACA;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,oBAAoB;IACxB;AACJ","sourcesContent":[".hr-org-body{\n    border-bottom: 1.27532px solid #EAEAEA;\n}\n.hr-org-title{\nborder-bottom:1.894px solid rgba(140, 174, 120, 0.12);\n}\n.hi-name{\npadding: 0 7%;\ncolor: #424242;\nfont-size: 30px;\nmargin-top:2rem;\n}\n.db-tabs-div{\npadding: 0 7%;    \n}\n.db-tabs-div .MuiButtonBase-root{\npadding:0 !important;\nmin-width:auto !important;\nmargin-right:30px;\nmargin-top: 10px;\n}\n.db-tab{\ncolor: #424242 !important;\nopacity: 0.6 !important;\nfont-size:14px !important;\n}\n.db-tabs-div .Mui-selected{\ncolor:#68AD3F !important;\nopacity: 1 !important;  \n}\n.db-body{\nbackground-color: #FAFAFA;\npadding: 0 7%;\nmin-height:90vh;\npadding-bottom: 100px;\n}\n.db-org-title{\ncolor:#424242;\nfont-size:22px;\nfont-weight: 500;\n}\n.db-dropdown .dropdown-toggle::after {\ndisplay: none;\n}\n.create-event-opt{\ncursor:pointer;\nheight: 42px;\nfont-size: 14px;\ncolor: #000000;\n}\n.db-tab-container .MuiTabPanel-root{\npadding: 0 !important;\n}\n.dashboardPopover  .MuiPopover-paper {\nright: 7% !important;\nwidth: 185px !important;\nleft: auto !important;\n}\n\n@media only screen and (min-width: 0px) and (max-width: 480px) {\n.hi-name{\n    padding: 0 5%;\n}\n.dashboardPopover .MuiPopover-paper {\n    right: 5% !important;\n}\n.db-body{\n    padding: 0 5%;\n}\n.db-tabs-div{\n    padding: 0 5%;    \n}\n.create-event{\n    font-size: 12px;\n    padding:7px 9px;\n}\n.db-tabs-div .MuiTabs-indicator{\nbottom: 0px !important;\n}\n}\n\n@media only screen and (min-width: 481px) and (max-width: 767px) {\n.hi-name{\n    padding: 0 5%;\n}\n.dashboardPopover .MuiPopover-paper {\n    right: 5% !important;\n}\n.db-body{\n    padding: 0 5%;\n}\n.db-tabs-div{\n    padding: 0 5%;    \n}\n.db-tabs-div .MuiTabs-indicator{\n    bottom: 0px !important;\n}\n}\n\n@media only screen and (min-width: 768px) and (max-width: 1024px) {\n    .db-body,.db-tabs-div,.hi-name{\n        padding: 0 7%;\n    }\n    .dashboardPopover .MuiPopover-paper {\n        right: 7% !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
